const slugify = (text) =>
  text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w-]+/g, "") // Remove all non-word chars
    .replace(/--+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text

const DEFAULT_SORT_ORDER = Number.MAX_SAFE_INTEGER;

const createItemSortOrder =
  (orderMap = {}) =>
  (slug) =>
    Object.prototype.hasOwnProperty.call(orderMap, slug) ? orderMap[slug] : DEFAULT_SORT_ORDER;

module.exports = {
  slugify,
  createItemSortOrder,
};
